// extracted by mini-css-extract-plugin
module.exports = {"left":"SocialMediaStep_left__s2qhz","container":"SocialMediaStep_container__hj4lB","text":"SocialMediaStep_text__gK6PQ"};